import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { login, generateLoginOTP, refreshCaptcha, setCaptcha } from '../actions/signinAction';
import { readCookie } from '../../utils/Cookie';
import { parseSearch } from '../../modules/ajio-util/query';
import { showModal, hideModal } from '../../actions/modal.js';
import SignInWithOTP from './SignInWithOTPComponent';
import { validateMobile, validateEmail } from '../../utils/inputValidator';
import cleverTapPushEvent from '../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../modules/ajio-util/cleverTap/eventConstants';
import { createRedirectUri } from '../../utils/redirectUtil';
import { signInCheck } from '../../components/common/CheckUserStatus';
import screen from '../../utils/pageType';
import { gtmEventPush, segmentEventPush } from '../../modules/ga/GTMdatalayer';

import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';

import FloatingInput from './floating-input';

class OldPassword extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRefreshCaptcha = this.handleRefreshCaptcha.bind(this);
    this.state = {
      errorMsg: '',
      password: '',
      showTxt: false,
      showPwdClicked: false,
      hideTxt: false,
      otpClicked: false,
      captchaText: ''
    };
  }

  componentDidMount() {
    const { mobileNumberFromStore, emailFromStore } = this.props;
    if (!(mobileNumberFromStore || emailFromStore)) {
      window.location.href = '/login';
    }
    const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
    const { login_password: { pageType = '', pageName = '' } = {} } = screen;
    const { location: { search = '' } = {} } = window;
    const queryObj = parseSearch(search) || '';
    const { referrer = '', login_source = '' } = queryObj;
    localStorage.setItem('LoginModelType', pageName);
    localStorage.setItem('LoginBackButtonType', pageName);
  }

  handleSubmit(event, userInfo, userAccObj) {
    event.preventDefault();
    if (!this.state.password) {
      gtmEventPush({
        page_name: 'login password screen',
        page_type: 'user account screen',
        event: 'formError',
        category: 'formError',
        action: 'login password form',
        label: 'Please enter a valid password'
      });
      this.setState({
        errorMsg:
          'Password should have minimum 8 characters with at least one number, one alphabet and one special character.'
      });
    } else {
      var signInObj = {};
      let userData = Object.keys(userAccObj).length > 0 ? Object.values(userAccObj)[0] : userInfo;
      signInObj = {
        username: userData,
        password: this.state.password,
        device: this.props.viewSiteAs,
        captchaInput: this.state.captchaText
      };
      const { queryString = '', location: { pathname = '' } = {} } = this.props;
      this.props.login(
        signInObj,
        () => {
          if (this.props.validUser) {
            // ga('send', {
            //   eventCategory: 'Login',
            //   eventAction: "Glad you're back",
            //   eventLabel: 'Start shopping - Success'
            // });
            const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
            const { login_password: { pageType = '', pageName = '' } = {} } = screen;
            const { location: { search = '' } = {} } = window;
            const queryObj = parseSearch(search) || '';
            const { referrer = '', login_source = '' } = queryObj;
            gtmEventPush({
              event: 'login_success',
              login_method: 'password',
              referral_page: referrer.slice(1),
              login_source: referrer.slice(1),
              user_type: loginStatus,
              page_type: pageType,
              page_name: pageName
            });
            // Segment Push Event
           segmentEventPush({
              event: 'Login or Signup Successful',           
              gender : '',
              referral_code: refererDetails?.referralCode,
              screen_name: pageType,
              type: `password`,
            });

            gtmEventPush({
              page_name: 'login password screen',
              page_type: 'user account screen',
              event: 'user_account_interactions',
              category: 'user account interactions',
              action: 'Login with Password',
              label: 'Start shopping - success'
            });
            cleverTapPushEvent({
              eventName: CLEVERTAP_EVENT_NAMES.User_Sign_In,
              eventObj: {
                source: 'Sign In Page',
                type: 'Login Via EMail Id and Password',
                user_id: userData,
                platform: 'MSITE'
              }
            });
            this.setState({
              errorMsg: ''
            });
            const redirectURI = createRedirectUri(queryString);
            if (this.props.viewSiteAs == 'desktop') {
              if (pathname == '/login' || pathname == '/login/password') {
                window.location = redirectURI;
              } else {
                // close modal
                this.props.hideModal('sign-in-up');
                let { location: { href = '' } = {} } = window;
                if (!href.includes('/cart')) {
                  window.location.reload();
                }
              }
            } else {
              window.location = redirectURI;
            }
          } else if (this.props.statusCode === 400 || this.props.statusCode === 401) {
            ga('send', {
              eventCategory: 'Login',
              eventAction: "Glad you're back",
              eventLabel: 'Start shopping - Failure'
            });
            this.setState({
              errorMsg: this.props.message,
              captchaText: ''
            });
            gtmEventPush({
              page_name: 'login password screen',
              page_type: 'user account screen',
              event: 'user_account_interactions',
              category: 'user account interactions',
              action: 'Login with Password',
              label: 'Start shopping - failure'
            });
          }
        },
        () => {
          const { userCred = '' } = this.props;
          let userInfo;
          if (readCookie('uI')) {
            userInfo = decodeURIComponent(readCookie('uI'));
          } else {
            userInfo = userCred;
          }
          this.generateOTP(userInfo);
        }
      );
    }
  }

  generateOTP(userInfo) {
    if (this.props.viewSiteAs == 'desktop') {
      this.setState({
        otpClicked: true
      });
    }

    const { history = {}, queryString = '' } = this.props;
    let queryObj = parseSearch(queryString);
    let userData = {};
    if (validateMobile(userInfo)) {
      userData = { mobileNumber: userInfo };
    } else if (validateEmail(userInfo)) {
      userData = { emailId: userInfo };
    }

    this.props.generateLoginOTP(userData, () => {
      if (this.props.otpSuccess) {
        let redirectURI = '/';
        redirectURI = queryObj.referrer ? redirectURI + queryObj.referrer : redirectURI;
        if (this.props.viewSiteAs == 'desktop') {
          this.setState({
            otpClicked: true
          });
        } else {
          let lastVisit = window.location.href;
          if (lastVisit.includes('?referrer')) {
            lastVisit = lastVisit.split('?').slice(1);
            lastVisit = lastVisit.join('?');
            history.push({
              pathname: '/login/otp',
              search: lastVisit,
              state: {
                userData
              }
            });
          } else {
            history.push({
              pathname: '/login/otp',
              search: redirectURI,
              state: {
                userData
              }
            });
          }
        }
      }
    });
  }

  showPwd(toggleState) {
    let inputPwd = document.getElementById('pwdInput');
    if (toggleState) {
      if (inputPwd.type == 'password') {
        inputPwd.type = 'text';
      }
    } else {
      inputPwd.type = 'password';
    }
  }

  resendOTPforAuthCB = () => {
    this.generateOTP(decodeURIComponent(readCookie('uI')));
  };

  handleRefreshCaptcha(userAccObj, userInfo) {
    let userData = Object.keys(userAccObj).length > 0 ? Object.values(userAccObj)[0] : userInfo;
    this.props.refreshCaptcha({ username: userData, refreshCaptcha: true }, () => {
      this.setState({ errorMsg: '' });
    });
    gtmEventPush({
      page_name: 'login password screen',
      page_type: 'user account screen',
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'Captcha Refresh'
    });
  }

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;

    const {
      queryString = '',
      existingUserSignUp = {},
      userCred = '',
      userAccObj = {},
      flags = {},
      displayEmail = false
    } = this.props;
    let userInfo;
    if (readCookie('uI')) {
      userInfo = decodeURIComponent(readCookie('uI'));
    } else {
      userInfo = userCred;
    }
    // let userInfo = decodeURIComponent(readCookie("uI")) ? decodeURIComponent(readCookie("uI")) : userCred ;
    if (this.state.otpClicked) {
      return (
        <SignInWithOTP
          viewSiteAs={this.props.viewSiteAs}
          resendOTP={this.resendOTPforAuthCB}
          userCred={userCred}
          hideLoader
          queryString={queryString}
        />
      );
    } else {
      return (
        <div className={`${newDesignLuxe ? 'luxe-newdesign' : ''} old-pwd-view`}>
          <form
            className="login-form"
            onSubmit={e => this.handleSubmit(e, userInfo, userAccObj)}
            data-ga-event-category="Sign Up"
            data-ga-event-action="Welcome to AJIO"
            data-ga-event-label="Screen Launch"
          >
            <h1> Glad you&#39;re back! </h1>
            {this.props.existingUserSignUp ? (
              <div className="old-user-signup">
                <h4> An account already exists with </h4>
                <h3> {existingUserSignUp.existingCred} </h3>
                {displayEmail ? <h3> {existingUserSignUp.associatedAcc} </h3> : null}
              </div>
            ) : null}
            <div
              className="repeat-user-pwd"
              data-ga-event-category="Login"
              data-ga-event-action="Glad you're back"
              data-ga-event-label="Screen Launch"
            >
              {newDesignLuxe ? (
                <div>
                  <FloatingInput
                    floatingText="Enter your password"
                    error={this.state.errorMsg}
                    type="password"
                    name="password"
                    id="pwdInput"
                    className={
                      this.state.showPwdClicked
                        ? 'login-form-inputs show-pwd-otp'
                        : 'login-form-inputs hide-pwd-otp'
                    }
                    placeholder="  "
                    size="32"
                    maxLength="20"
                    autoFocus={false}
                    autoComplete="off"
                    value={this.state.password}
                    onChange={e => {
                      this.setState({
                        password: e.target.value,
                        showTxt: true
                      });
                    }}
                  />

                  {/* Show and Hide password option */}
                  {this.state.showTxt ? (
                    <span
                      className="show-pwd"
                      data-ga-event-category="Login"
                      data-ga-event-action="Glad you're back"
                      data-ga-event-label={!this.state.hideTxt ? 'Show' : 'Hide'}
                      onClick={e => {
                        let toggleState = !this.state.showPwdClicked;
                        this.setState({
                          showPwdClicked: toggleState,
                          hideTxt: !this.state.hideTxt
                        });
                        this.showPwd(toggleState);
                      }}
                    >
                      {!this.state.hideTxt ? 'Show' : 'Hide'}
                    </span>
                  ) : null}
                </div>
              ) : (
                ''
              )}

              {newDesignLuxe ? (
                ''
              ) : (
                <label className="label-pwd">
                  {' '}
                  Enter your password
                  <input
                    type="password"
                    name="password"
                    id="pwdInput"
                    className={
                      this.state.showPwdClicked
                        ? 'login-form-inputs show-pwd-otp'
                        : 'login-form-inputs hide-pwd-otp'
                    }
                    placeholder=""
                    size="32"
                    maxLength="20"
                    autoFocus
                    autoComplete="off"
                    value={this.state.password}
                    onChange={e => {
                      this.setState({
                        password: e.target.value,
                        showTxt: true
                      });
                    }}
                  />
                  {/* Show and Hide password option */}
                  {this.state.showTxt ? (
                    <span
                      className="show-pwd"
                      data-ga-event-category="Login"
                      data-ga-event-action="Glad you're back"
                      data-ga-event-label={!this.state.hideTxt ? 'Show' : 'Hide'}
                      onClick={e => {
                        gtmEventPush({
                          page_name: 'login password screen',
                          page_type: 'user account screen',
                          event: 'user_account_interactions',
                          category: 'user account interactions',
                          action: this.state.showPwdClicked ? 'Hide Password' : 'Show Password'
                        });
                        let toggleState = !this.state.showPwdClicked;
                        this.setState({
                          showPwdClicked: toggleState,
                          hideTxt: !this.state.hideTxt
                        });
                        this.showPwd(toggleState);
                      }}
                    >
                      {!this.state.hideTxt ? 'Show' : 'Hide'}
                    </span>
                  ) : null}
                </label>
              )}
              {/* Display error message when password is incorrect */}
              {this.state.errorMsg ? (
                <div
                  id="error-msg"
                  className="error-msg"
                  data-ga-event-category="Login"
                  data-ga-event-action="Glad you're back"
                  data-ga-event-label={this.state.errorMsg}
                  aria-live='polite'
                >
                  {this.state.errorMsg}
                </div>
              ) : null}
            </div>
            {this.props.captchaData !== '' && (
              <div className="box-margin captcha-alignment">
                <label className="label-pwd">
                  {' '}
                  Enter captcha
                  <div>
                    <img src={`data:image/png;base64, ${this.props.captchaData}`} />
                    <span
                      className="ic-easy-return"
                      onClick={() => {
                        console.log('=====================');
                        this.handleRefreshCaptcha(userAccObj, userInfo);
                      }}
                    />
                  </div>
                  {newDesignLuxe ? (
                    <FloatingInput
                      error={this.state.errorMsg}
                      placeholder="  "
                      floatingText="Enter captcha"
                      type="text"
                      className="login-form-inputs"
                      value={this.state.captchaText}
                      onChange={e => {
                        this.setState({
                          captchaText: e.target.value
                        });
                      }}
                    />
                  ) : (
                    ''
                  )}
                  {newDesignLuxe ? (
                    ''
                  ) : (
                    <input
                      type="text"
                      className="login-form-inputs"
                      value={this.state.captchaText}
                      onChange={e => {
                        this.setState({
                          captchaText: e.target.value
                        });
                      }}
                    />
                  )}
                </label>
              </div>
            )}
            <div className="box-margin">
              <input
                type="submit"
                className="login-form-inputs login-btn"
                value="START SHOPPING"
                onClick={() => {
                  gtmEventPush({
                    page_name: 'login password screen',
                    page_type: 'user account screen',
                    event: 'user_account_interactions',
                    category: 'user account interactions',
                    action: 'Start shopping'
                  });
                }}
              />
            </div>

            <div className="login-form-inputs forgot-text">Forgot your password?</div>

            <div>
              <input
                type="button"
                className={
                  this.state.errorMsg == ''
                    ? 'login-form-inputs only-border-btn'
                    : 'login-form-inputs login-btn'
                }
                value="LOGIN WITH OTP"
                onClick={() => {
                  this.generateOTP(userInfo);
                  // ga('send', {
                  //   eventCategory: 'Login',
                  //   eventAction: "Glad you're back",
                  //   eventLabel: 'Login with OTP'
                  // });
                  gtmEventPush({
                    event: 'link_click',
                    screen_type: `otp`,
                    link_text: `LOGIN WITH OTP`,
                    user_login_step: 3,
                    page_type: 'login page',
                    page_name: 'Login Enter OTP'
                  });
                  gtmEventPush({
                    page_name: 'login password screen',
                    page_type: 'user account screen',
                    event: 'user_account_interactions',
                    category: 'user account interactions',
                    action: 'Login with OTP'
                  });
                  cleverTapPushEvent({
                    eventName: CLEVERTAP_EVENT_NAMES.User_Sign_In,
                    eventObj: {
                      source: 'Sign In Page',
                      type: 'Login Via EMail Id and OTP',
                      user_id: userInfo,
                      platform: 'MSITE'
                    }
                  });
                }}
              />
            </div>

            <div className="login-form-inputs btn-action-txt otp-text">
              We will send an OTP to your registered mobile number.
            </div>
          </form>
          {this.props.existingUserSignUp ? (
            <div className="disable-state">
              You can change the Email ID associated with your account in the ‘My Account’ Page.
            </div>
          ) : null}
        </div>
      );
    }
  }

  componentWillUnmount() {
    this.props.setCaptcha();
  }
}

const mapDispatchToProps = dispatch => {
  return {
    login: (formData, callback, catchCallback) => {
      dispatch(login(formData, callback, catchCallback));
    },
    generateLoginOTP: (mobile, callbackOtp) => {
      dispatch(generateLoginOTP(mobile, callbackOtp));
    },
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    refreshCaptcha: data => {
      dispatch(refreshCaptcha(data));
    },
    setCaptcha: () => {
      dispatch(setCaptcha(''));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const { signInReducer = {}, httpError = {}, signInOTPReducer = {}, flags = {} } = state;
  const {
    validUser = false,
    userName = '',
    captchaData = '',
    emailId = '',
    mobileNumber = ''
  } = signInReducer;
  console.log('SIGN IN REDUCER', signInReducer);
  const { otpSuccess = false } = signInOTPReducer;
  const { error = {} } = httpError;
  const { statusCode = '', message = '' } = error;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    newDesignLuxe,
    httpError,
    validUser,
    statusCode,
    otpSuccess,
    userName,
    captchaData,
    message,
    emailFromStore: emailId,
    mobileNumberFromStore: mobileNumber,
    flags
  };
};

export default OldPassword = withRouter(connect(mapStateToProps, mapDispatchToProps)(OldPassword));
